import React from 'react';
import ReceiptItemRow from './ReceiptItemRow.js';

const ReceiptItemsList = ({ receiptItems, onQuantityChange, onRemove }) => {
  return (
    <div className="flex-1 overflow-y-auto pr-1">
      <div className="grid grid-cols-[1.7fr_0.8fr_0.8fr_0.8fr_auto] gap-3 pb-3 border-b border-gray-200 text-lg uppercase tracking-wide text-gray-500">
        <span>Item</span>
        <span>Qty</span>
        <span>Price</span>
        <span>Subtotal</span>
        <span />
      </div>
      <div className="space-y-2 mt-4 h-[220px] 2xl:h-[400px] overflow-auto">
        {receiptItems.length === 0 ? (
          <div className="text-center text-gray-500 py-10">No items added to receipt yet.</div>
        ) : (
          receiptItems.map((item) => (
            <ReceiptItemRow
              key={item.id}
              item={item}
              onQuantityChange={onQuantityChange}
              onRemove={onRemove}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default ReceiptItemsList;
